import React from 'react';
import Image from 'next/image';

function LoginLeftColumn() {
  return (
    <div className="login-left-column">
      {/* Microphone watermark — the existing SVG acts as a decorative bg */}
      <div className="watermark">
        <Image
          src="/left-column.svg"
          alt=""
          fill
          sizes="50vw"
          style={{ objectFit: 'cover', objectPosition: 'center bottom' }}
          priority
        />
      </div>

      {/* Text content */}
      <div className="left-content">
        <h1 className="left-heading">
          Turn your audience into your supporters.
          <br />
          Receive support through donations from your fans.
        </h1>

        <p className="left-body">
          Connect, share, and grow your community in one place.
          <br />
          Build lasting connections powered by genuine support.
          <br />
          Inspire others with your creativity.
        </p>
      </div>

      <style jsx>
        {`
.login-left-column {
  position: relative;
  isolation: isolate;
  flex: 1 1 50%;
  max-width: 50%;
  width: 50%;
  min-height: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #26B0FB;
  box-sizing: border-box;
  padding: 0 clamp(20px, 6vw, 100px);
}

@media (max-width: 768px) {
  .login-left-column {
    flex: none;
    align-self: stretch;
    max-width: 100%;
    width: 100%;
    min-height: auto;
    height: auto;
    padding: 64px 16px;
    align-items: center;
    justify-content: center;
  }
}

        /* Ensure background fills completely - extra layer for safety */
        .login-left-column::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: #26B0FB;
          z-index: 0;
        }

        .watermark {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 1;
          width: 100%;
          height: 100%;
        }

        .left-content {
          position: relative;
          z-index: 2;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          gap: clamp(24px, 3vw, 40px); /* Fluid gap */
          max-width: 560px;
          width: 100%;
          padding-top: 4px;
        }

        @media (max-width: 768px) {
          .left-content {
            max-width: 100%;
            width: 100%;
            padding-top: 0;
          }
        }

        .left-heading {
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: clamp(28px, 3.5vw, 44px); /* Improved fluid scaling */
          line-height: 1.2;
          color: #ffffff;
          margin: 0;
          padding: 0 10px;
          text-align: left;
        }

        .left-body {
          font-family: 'Inter', sans-serif;
          font-weight: 500;
          font-size: clamp(16px, 1.8vw, 22px); /* Improved fluid scaling */
          line-height: 1.3;
          color: #ffffff;
          margin: 0;
          padding: 0 10px;
          text-align: left;
        }
      `}
      </style>
    </div>
  );
}

export default LoginLeftColumn;
